<template>
  <div class="sku">
    <el-alert
      v-if="skus.length > 0"
      style="margin-bottom: 20px;"
      title="票券说明"
      type="warning"
     >
      <slot name="description">
        <li>价格展示优先级:指定日期 > 星期价格 > 默认价格，默认价格为必填项</li>
        <li>运营豆仅限超管修改，其他用户修改无效</li>
      </slot>
    </el-alert>
    <div class="sku-item" v-for="(sku,index) in skus" v-if="sku.is_del === false">
      <el-form :model="sku" :rules="validateRules" label-width="80px" size="small">
        <el-form-item label="票券名称" prop="title">
          <el-input v-model="sku.title"></el-input>
        </el-form-item>
        <el-form-item label="票券库存" prop="stock">
          <el-input v-model="sku.stock"></el-input>
        </el-form-item>
        <el-form-item label="价格信息" prop="price">
          <i-price v-model="sku.price_info"></i-price>
        </el-form-item>
        <el-form-item v-if="needPlayList" label="绑定场次" prop="play_list">
          <el-select v-model="sku.play_ids" multiple filterable allow-create default-first-option placeholder="请选择预约场次" style="width: 100%">
            <el-option v-for="item in playList" :key="item.play_id" :label="item.play_time+'-'+item.play_name+'-'+item.guide_user_name" :value="item.play_id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <i class="el-icon-circle-close delete" @click="delSku(index)"></i>
    </div>
    <div class="add-sku" @click="addSku">
      <i class="el-icon-plus"></i> &nbsp添加规格
    </div>
  </div>
</template>

<script>
import iPrice from "@/components/i-price"

export default {
  name: "i-sku",
  components: {iPrice},
  props: {
    input: {
      type: Array
    },
    needPlayList: {
      type: Boolean,
      default: false
    },
    value: {}
  },
  data() {
    return {
      skus: [],
      playList: [],
      validateRules: {
        title: [
          {required: true, message: '请输入套餐名称', trigger: 'blur'},
        ],
        stock: [
          {required: true, message: '请输入库存', trigger: 'blur'},
        ],
        play_list: [
          {required: true, message: '请选择预约场次', trigger: 'blur'},
        ],
        price_info: [
          {required: true, message: '至少选择一个价格', trigger: 'blur'},
        ]
      }
    }
  },
  methods: {
    addSku: function () {
      this.skus.push({
        title: '',
        stock: '',
        is_del: false,
        play_ids:[],
        price_info: []
      });
    },
    delSku: function (index) {
      if (this.skus[index].hasOwnProperty('sku_id')) {
        this.skus[index].is_del = true;
      } else {
        this.skus.splice(index, 1)
      }
    },
    initPlayList:function (){
      let _self = this;
      if(this.needPlayList){
        this.$http.request('playList').then(res=>{
          _self.playList = res.data;
        });
      }
    }
  },
  created() {
    this.initPlayList();
  },
  watch: {
    skus: function () {
      this.$emit('input', this.skus)
    },
    value: function () {
      this.skus = this.value;
    }
  }
}
</script>

<style scoped lang="less">
.sku {

}

.delete {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 20px;
  color: @color-danger;
  cursor: pointer;
}

.add-sku {
  border: 1px dashed @border-color;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: @normal-text-font-size;
  cursor: pointer;
}

.add-sku:hover {
  background: #f8f8f8;
}

.sku-item {
  border: 1px solid @border-color;
  margin-bottom: 20px;
  min-height: 40px;
  position: relative;
  padding: 40px 20px 0 20px;
}

.sku-item:hover {
  box-shadow: 2px 2px 10px @border-color;
}
</style>



// WEBPACK FOOTER //
// src/components/i-sku.vue